import { render } from "./ProductFeed.vue?vue&type=template&id=095b4afc&scoped=true"
import script from "./ProductFeed.vue?vue&type=script&lang=js"
export * from "./ProductFeed.vue?vue&type=script&lang=js"

import "./ProductFeed.vue?vue&type=style&index=0&id=095b4afc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095b4afc"]])

export default __exports__